// removed by extract-text-webpack-plugin
module.exports = {"hiddenRadio":"DibsRadioButtonInput-style__hiddenRadio__33viD","radioButton":"DibsRadioButtonInput-style__radioButton__3A8M9","labelClass":"DibsRadioButtonInput-style__labelClass__1sUp5","titleWrapper":"DibsRadioButtonInput-style__titleWrapper__3srtN","titleClass":"DibsRadioButtonInput-style__titleClass__3fodP"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/DibsRadioButtonInput-style.scss
// module id = 3058
// module chunks = 64